import {Component, OnInit} from '@angular/core';
import {Translations} from '../../../services/translations.service';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../../services/toast.service';
import {SessionStorageService} from '../../../services/session-storage.service';
import {ActivatedRoute, Router} from '@angular/router';
import {RoutingConstants} from '../../../models/routing/routing-constants';
import {RestApiService} from '../../../services/api/rest-api.service';
import {FormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {NgIf} from '@angular/common';
import {Button, ButtonDirective} from 'primeng/button';
import {Ripple} from 'primeng/ripple';

const {params} = RoutingConstants;

@Component({
  standalone: true,
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  imports: [
    TranslatePipe,
    FormsModule,
    InputText,
    NgIf,
    Button,
    ButtonDirective,
    Ripple
  ],
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  readonly RoutingConstants = RoutingConstants;
  loading = false;
  password: string = '';
  repeatPassword: string = '';
  userId: number = 0;
  requestCode: string = '';
  passwordChanged = false;

  constructor(public translations: Translations,
              private translateService: TranslateService,
              private api: RestApiService,
              private toastService: ToastService,
              private storage: SessionStorageService,
              private route: ActivatedRoute,
              private router: Router) {
    if (this.route.snapshot.params[params.id.substring(1)]) {
      this.userId = parseInt(this.route.snapshot.params[params.id.substring(1)], 10);
      this.requestCode = this.route.snapshot.queryParams[params.code.substring(1)];
    }
  }

  ngOnInit(): void {
  }

  async resetPassword() {
    if (!this.password || !this.repeatPassword) {
      this.toastService.error(
        this.translateService.instant(this.translations.commons.error),
        this.translateService.instant(this.translations.commons.compileAllFields)
      );
      return;
    }

    if (this.password !== this.repeatPassword) {
      this.toastService.error(
        this.translateService.instant(this.translations.commons.error),
        this.translateService.instant(this.translations.auth.repeatPasswordError)
      );
      return;
    }

    // TODO CAS-147 unificare controllo requisiti minimi nuova password
    if (this.password.length < 10) {
      this.toastService.error(
        this.translateService.instant(this.translations.commons.error),
        this.translateService.instant(this.translations.profileSettings.changePassword.minimumPasswordLength)
      );
      return;
    }

    try {
      this.loading = true;
      await this.api.users.resetPassword({password: this.password, userId: this.userId, code: this.requestCode});
      this.toastService.success(
        this.translateService.instant(this.translations.auth.recoverPassword),
        this.translateService.instant(this.translations.auth.passwordChanged),
      );
      this.passwordChanged = true;
    } finally {
      this.loading = false;
    }


  }
}
